module.exports = __webpack_public_path__ + "media/images/pic/home/video-courses-934d3a8f7c350377a211cd9432c80de8.png";